import React, { useState } from "react";
import { Col, Row, Card, Form, Button, ProgressBar } from '@themesberg/react-bootstrap';
import { db } from "../../config/firebase";
import { uploadToR2, generateUUID } from "../../utils/r2Upload";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { useHistory } from "react-router-dom";

export default () => {
    const [formData, setFormData] = useState({
        title: "",
        message: "",
        targetAudience: "all",
        deepLink: "",
        imageFile: null
    });
    const [loading, setLoading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const history = useHistory();

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData(prev => ({ ...prev, imageFile: file }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.title || !formData.message || !formData.imageFile) {
            alert("Lütfen başlık, mesaj ve görsel alanlarını doldurun.");
            return;
        }

        setLoading(true);

        try {
            // 1. Upload Image to R2
            const file = formData.imageFile;
            const fileExt = file.name.split('.').pop();
            const fileName = `notifications/photo_${Date.now()}.${fileExt}`;
            const downloadURL = await uploadToR2(file, fileName, (progress) => {
                setUploadProgress(progress);
            });

            // 2. Call Cloud Function
            const functions = getFunctions();
            const sendNotification = httpsCallable(functions, 'sendNotification');

            const payload = {
                title: formData.title,
                message: formData.message,
                userIds: formData.targetAudience === "all" ? null : [],
                imageUrl: downloadURL,
                deepLink: formData.deepLink || null
            };

            const response = await sendNotification(payload);
            const result = response.data;

            alert(`Fotoğraflı bildirim başarıyla gönderildi!\nBaşanlı: ${result.sentCount || 0} kullanıcı\nBaşarısız: ${result.failedCount || 0} kullanıcı`);
            setFormData({
                title: "",
                message: "",
                targetAudience: "all",
                deepLink: "",
                imageFile: null
            });
            setUploadProgress(0);
        } catch (error) {
            console.error("Error submitting notification:", error);
            alert("Bir hata oluştu: " + error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="py-4">
                <h4>Fotoğraflı Bildirim Gönder</h4>
                <p className="text-muted mb-0">Bildirimler / Fotoğraflı Bildirim</p>
            </div>

            <Card className="border-0 shadow-sm mb-4">
                <Card.Body>
                    <Form onSubmit={handleSubmit}>
                        <Row className="mb-3">
                            <Col md={12}>
                                <Form.Group>
                                    <Form.Label>Başlık *</Form.Label>
                                    <Form.Control
                                        type="text"
                                        required
                                        placeholder="Bildirim Başlığı"
                                        value={formData.title}
                                        onChange={(e) => { const val = e.target.value; setFormData(prev => ({ ...prev, title: val })); }}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col md={12}>
                                <Form.Group>
                                    <Form.Label>Mesaj *</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={4}
                                        required
                                        placeholder="Bildirim Mesajı..."
                                        value={formData.message}
                                        onChange={(e) => { const val = e.target.value; setFormData(prev => ({ ...prev, message: val })); }}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col md={12}>
                                <Form.Group>
                                    <Form.Label>Görsel Seç *</Form.Label>
                                    <Form.Control
                                        type="file"
                                        accept="image/*"
                                        required
                                        onChange={handleFileChange}
                                    />
                                    <small className="text-muted">Kullanıcılara gösterilecek fotoğrafı seçin.</small>
                                </Form.Group>
                                {formData.imageFile && (
                                    <div className="mt-2 text-info">
                                        Seçilen Dosya: {formData.imageFile.name}
                                    </div>
                                )}
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col md={12}>
                                <Form.Group>
                                    <Form.Label>Hedef Kitle</Form.Label>
                                    <Form.Select
                                        value={formData.targetAudience}
                                        onChange={(e) => { const val = e.target.value; setFormData(prev => ({ ...prev, targetAudience: val })); }}
                                    >
                                        <option value="all">Tüm Kullanıcılar</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="mb-4">
                            <Col md={12}>
                                <Form.Group>
                                    <Form.Label>Deep Link (Opsiyonel)</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Örn: jigogo://profile/123"
                                        value={formData.deepLink}
                                        onChange={(e) => { const val = e.target.value; setFormData(prev => ({ ...prev, deepLink: val })); }}
                                    />
                                    <small className="text-muted">Kullanıcı bildirime tıkladığında gidilecek ekran (uygulama içi uyumlu olmalı).</small>
                                </Form.Group>
                            </Col>
                        </Row>

                        {uploadProgress > 0 && uploadProgress < 100 && (
                            <Row className="mb-3">
                                <Col md={12}>
                                    <ProgressBar now={uploadProgress} label={`${Math.round(uploadProgress)}%`} />
                                </Col>
                            </Row>
                        )}

                        <div className="d-flex justify-content-end">
                            <Button variant="primary" type="submit" disabled={loading}>
                                {loading ? "Gönderiliyor..." : "Gönder"}
                            </Button>
                        </div>
                    </Form>
                </Card.Body>
            </Card>
        </>
    );
};
